import { apiFetch } from "../utils/api";

export const fetchProcessStages = async (idToken, setProcessStages) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/lookups?key=process_stage`);
  res.then(async (response) => {
    let sortedData = response.data.sort((a, b) => a.value.localeCompare(b.value));
    setProcessStages(sortedData);
  });
};

export const fetchProducts = async (idToken, currentPartner, productSearch, contractTermFilter, productGroupFilter, skuTypeFilter, setPriceList) => {
  let tk = await idToken();
  let url = `/api/products?partner=${currentPartner.partner_id}&company_id=${currentPartner.company_id}`;
  if (productSearch) {
    url = url + `&searchTerm=${encodeURIComponent(productSearch)}`
  }
  if (contractTermFilter && contractTermFilter !== 'all') {
    url = url + `&contractTerm=${encodeURIComponent(contractTermFilter)}`
  }
  if (productGroupFilter && productGroupFilter !== 'all') {
    url = url + `&productGroup=${encodeURIComponent(productGroupFilter)}`
  }
  if (skuTypeFilter && skuTypeFilter !== 'all') {
    url = url + `&skuType=${encodeURIComponent(skuTypeFilter)}`
  }
  const res = apiFetch(tk, url);
  // res.then(async (response) => {
  //   setPriceList(response.data)
  // });

  res.then(async (response) => {
    let data = response.data;
    
      data = data.filter(
        item => item.autodesk_sku_type === 'M2S New' || item.autodesk_sku_type === 'Subscription New'
      );
    
    setPriceList(data);
  });
};

export const fetchContractTerms = async (idToken, setcontractTerms) => {
  let tk = await idToken();
  let url = `/api/products/terms`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setcontractTerms(response.data)
  });
};

export const fetchSKUTypes = async (idToken, setSkuTypes) => {
  let tk = await idToken();
  let url = `/api/products/auto_desk_types`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setSkuTypes(response.data)
  });
};

export const fetchProductDescriptions = async (idToken, setDescriptions) => {
  let tk = await idToken();
  let url = `/api/products/descriptions`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setDescriptions(response.data)
  });
};

export const fetchContracts = async (idToken, currentPartner, selectedCustomer, setsetContracts) => {
  let tk = await idToken();
  let url = `/api/end_users/contracts?partner_id=${currentPartner.partner_id}&company_id=${currentPartner.company_id}&end_user_id=${selectedCustomer.end_user_id}`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setsetContracts(response.data)
  });
};

export const fetchOpportunityContractTerms = async (idToken, partnerId, companyId, contract, setContractTerms) => {
  let tk = await idToken();
  let url = `/api/opportunities/contract_terms?partner_id=${partnerId}&company_id=${companyId}&contract=${contract}`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setContractTerms(response.data)
  });
};

export const fetchEndUserContacts = async (idToken, currentPartner, endUserId, setEndUserContacts) => {
  let tk = await idToken();
  let url = `/api/end_users?partner_id=${currentPartner.partner_id}&company_id=${currentPartner.company_id}&end_user_id=${endUserId}`;
  const res = apiFetch(tk, url);
  res.then(async (response) => {
    setEndUserContacts(response.data)
  });
};

export const fetchEndUsers = async (idToken, currentPartner, customerSearchTerm, setLocalEndUsers) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/partners/end_users?partner_id=${currentPartner.partner_id}&search_term=${customerSearchTerm}&company_id=${currentPartner.company_id}`);
  res.then(async (response) => {
    setLocalEndUsers(response.data);
  });
};

export const fetchSegments = async (idToken, setSegments) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/end_users/segments`);
  res.then(async (response) => {
    setSegments(response.data);
  });
};

export const fetchDriverDetailsLookup = async (idToken, setDriverDetailOptions) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/lookups?key=driver_detail`);
  res.then(async (response) => {
    let sortedData = response.data.sort((a, b) => a.value.localeCompare(b.value));
    setDriverDetailOptions(sortedData);
  });
};

export const fetchReasonCodeLookup = async (idToken, setDriverDetailOptions) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/lookups?key=reason_group`);
  res.then(async (response) => {
    let sortedData = response.data.sort((a, b) => a.value.localeCompare(b.value));
    setDriverDetailOptions(sortedData);
  });
};

export const fetchCountriesLookup = async (idToken, setCountries) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/lookups?key=countries`);
  res.then(async (response) => {
    let sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name));
    setCountries(sortedData);
  });
};

export const fetchEvents = async (idToken, setEvents) => {
  let tk = await idToken();
  const res = apiFetch(tk, `/api/opportunities/events`);
  res.then(async (response) => {
    let sortedData = response.data.sort((a, b) => a.localeCompare(b));
    setEvents(sortedData);
  });
};

export const fetchOpportunities = async (idToken, currentPartner, page, perPage, searchTerm, filterStage, filterEvent, setIsLoading, setLocalOpportunities, setPagination) => {
  setIsLoading(true);
  try {
    let tk = await idToken();
    let url = `/api/opportunities?partner=${currentPartner.partner_id}&page=${page}&per_page=${perPage}&company_id=${currentPartner.company_id}`;
    if (searchTerm) {
      url += `&searchTerm=${searchTerm}`
    }
    if (filterStage && filterStage !== 'all') {
      url += `&stage=${filterStage}`
    }
    if (filterEvent && filterEvent !== 'all') {
      url += `&event=${filterEvent}`
    }
    const response = await apiFetch(tk, url);
    setLocalOpportunities(response.data);
    if (response.pagination) {
      setPagination({
        currentPage: response.pagination.current_page,
        totalPages: response.pagination.total_pages,
        totalCount: response.pagination.total_count,
        perPage: response.pagination.per_page,
      });
    }
  } catch (error) {
    console.error('Error fetching opportunities:', error);
  } finally {
    setIsLoading(false);
  }
};

export const getStageBadgeColor = (stage) => {
  if (stage.includes('06-Closed Won')) {
    return 'bg-worldsview-green/10 text-worldsview-green border-worldsview-green';
  }
  if (stage.includes('07-Closed Lost')) {
    return 'bg-worldsview-red/10 text-worldsview-red border-worldsview-red';
  }
  if (stage.includes('00-Nurturing')) {
    return 'bg-muted/50 text-muted-foreground border-muted-foreground';
  }
  if (stage.includes('01-Identify')) {
    return 'bg-worldsview-purple/10 text-worldsview-purple border-worldsview-purple';
  }
  if (stage.includes('02-Qualification')) {
    return 'bg-worldsview-blue/10 text-worldsview-blue border-worldsview-blue';
  }
  if (stage.includes('03-Needs Analysis')) {
    return 'bg-worldsview-blue/15 text-worldsview-blue border-worldsview-blue';
  }
  if (stage.includes('04-Proposal')) {
    return 'bg-worldsview-orange/10 text-worldsview-orange border-worldsview-orange';
  }
  if (stage.includes('05-Negotiation')) {
    return 'bg-worldsview-orange/15 text-worldsview-orange border-worldsview-orange';
  }
  return 'bg-worldsview-blue/10 text-worldsview-blue border-worldsview-blue';
};

export const generateOpportunityNumber = (currentPartner) => {
  var d = new Date();
  const minute = d.getHours() * 60 + d.getMinutes();
  return `${currentPartner.partner_id}-${crypto.randomUUID().toUpperCase()}`;
};